module.exports = __webpack_public_path__ + "public/images/orange_fingerprints_bottom_right.8b3dfa3dc03b76a1f1a92ac400c22ab5.png";